module.exports = __webpack_public_path__ + "static/media/contactlenses1.e9e6f33f.jpg";